import classNames from 'classnames'
import * as React from 'react'

import './ListHeader.scss'

interface ListHeaderProps {
  button?: JSX.Element | string
  imageSrc?: string
  noMarginLeft?: boolean
  noMarginBottom?: boolean
  isUppercase?: boolean
  children?: React.ReactNode | undefined
}

const ListHeader: React.FC<ListHeaderProps> = props => {
  const classes = classNames(
    'srprs-listheader',
    props.noMarginLeft ? `no-margin-left` : false,
    props.noMarginBottom ? 'no-margin-bottom' : false,
    props.isUppercase ? `is-uppercase` : false,
  )
  return (
    <div className={classes}>
      <span>{props.children}</span>
      {props.button}
      {props.imageSrc ? <img src={props.imageSrc} /> : null}
    </div>
  )
}

export default ListHeader
